;(function(){
	var init = function(wrapper) {
		var input = wrapper.querySelector('input');
		var label = wrapper.querySelector('label');
		var remove = wrapper.querySelector('button');

		var defaultLabel = label.innerText;

		var onChange = function() {
			var active = input.files.length;

			label.innerText = active ? input.files[0].name : defaultLabel;
			remove.classList[active ? 'remove' : 'add']('hidden');
		};

		input.addEventListener('change', onChange);

		remove.addEventListener('click', function() {
			input.value = null;
			onChange();
		});

		onChange();
	};

	[].slice.call(document.querySelectorAll('.js-file')).forEach(init);
}());
